
const KEY = {
    serviceID: "service_ixmpzjn",
    templateID: "template_ncdbot5",
    userID: "ISwKylpLqm-6UT4vc",
    privateID: "RAUVVWIkzJnuSGM2RM-rl"
}

export default KEY